export const getUserPermissions = () => ({
    method: 'get',
    url: 'permissions/v1/me',
});
